import { useCallback } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import * as Actions from '../../store/csw/csw.actions';

export const useShipDateState = (fulfillmentPlanId, onConfigurationChange) => {
  const dispatch = useDispatch();
  const onShipDateChange = useCallback(
    (formattedShipDate, dateFormat) => {
      const momentDate = moment(formattedShipDate, dateFormat);
      const newShipDate = momentDate.toISOString();
      onConfigurationChange({ shipDate: newShipDate });
      dispatch(
        Actions.updateShipmentConfiguration(fulfillmentPlanId, {
          shipDate: newShipDate,
        }),
      );
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  return {
    onShipDateChange,
  };
};
